import axios from "../utils/axios";

// ========== PAYMENT SETTINGS APIs ==========

// Get payment settings (Public)
export const getPaymentSettingsApi = (restaurantId) => {
  return axios.get(`/api/payment/settings/${restaurantId}`);
};

// Update payment settings
export const updatePaymentSettingsApi = (settingsData) => {
  return axios.put("/api/payment/settings", settingsData);
};

// ========== PAYMENT TRANSACTIONS APIs ==========

// Create new payment
export const createPaymentApi = (paymentData) => {
  return axios.post("/api/payment", paymentData);
};

// 🔥 NEW: Link payment to order
export const linkPaymentToOrderApi = (data) => {
  return axios.post("/api/payment/link-to-order", data);
};

// Get all payments with filters
export const getPaymentsApi = (params) => {
  return axios.get("/api/payment", { params });
};

// Get single payment by ID
export const getPaymentByIdApi = (id) => {
  return axios.get(`/api/payment/${id}`);
};

// Update payment status
export const updatePaymentStatusApi = (id, statusData) => {
  return axios.put(`/api/payment/${id}/status`, statusData);
};

// Get payment settings (Owner)
export const getOwnerPaymentSettingsApi = () => {
 return axios.get(`/api/payment/owner/settings`);
};

